import React from 'react';
import ReactModal from 'react-modal';
export const Modal = ({ isOpen, children, onRequestClose }) => {
    return (React.createElement(ReactModal, { isOpen: isOpen, style: {
            overlay: {},
            content: {},
        }, portalClassName: "portalClassName", overlayClassName: "overlayClassName", className: "className", bodyOpenClassName: "bodyOpenClassName", htmlOpenClassName: "htmlOpenClassName", onRequestClose: onRequestClose }, children));
};
Modal.setAppElement = ReactModal.setAppElement;
